import Action from "./Action";
import Shape from "../Main/Shape.js";
import {Serialization} from "../Main/Serializer";

export default class ShapeChangeNameAction implements Action {

    private readonly oldName: string;

    constructor(private shape: Shape, private newName: string) {
        this.oldName = this.shape.getName();
    }

    public apply() {
        this.shape.setName(this.newName);
    }

    public revert() {
        this.shape.setName(this.oldName);
    }

    public merge(newAction: Action): boolean {
        if(!(newAction instanceof ShapeChangeNameAction) || newAction.shape !== this.shape || newAction.oldName !== this.newName) {
            return false;
        }

        if((this.newName.length > this.oldName.length) !== (newAction.newName.length > newAction.oldName.length)) {
            return false;
        }

        this.newName = newAction.newName;
        this.apply();

        return true;
    }

    public serializeForDebug(): Serialization {
        return {
            shape: this.shape.id,
            oldName: this.oldName,
            newName: this.newName,
        };
    }
}
